module.exports = __webpack_public_path__ + "img/illu-intestine-sm.1ccb1c08.svg";